<template>
    <div>
        <van-nav-bar
            title="优惠咨询"
        />
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
        >
            <van-cell center  size="large" v-for="item in dataList" :key="item.id" :title="item.activity_name">
                <template slot="label" >
                    <span class="span_class">{{"项目："}}{{item.promotion_name?item.promotion_name.name:""}}</span>
                    <span class="span_class">{{"折扣率："}}{{item.rate}}%</span>
                </template>
            </van-cell>
        </van-list>
    </div>
</template>

<script>
import { NavBar, Cell, List } from 'vant';
import { PreferentialSalesApi } from '@/api/shop'
import { toErrorPage } from '@/utils/usePage'

export default {
    components: {
        [NavBar.name]: NavBar,
        [Cell.name]: Cell,
        [List.name]: List
    },
    data() {
        return {
            dataList: [],
            loading: false,
            finished: false,
            query: {
                page: 0
            }
        }
    },
    mounted(){
    },
    methods: {
        onLoad() {
             this.query.page+=1
             this.getPreferentialSales()
         },
         getPreferentialSales(){
            var that = this
            that.axios.get(PreferentialSalesApi, {params: that.query}).then((ret) => {
                that.loading = false
                if (ret.flag) {
                    let it = ret.details
                    it.results.forEach(item => {
                        this.dataList.push(item)
                    })
                    if (it.results == null || it.results.length ===0 || it.next == null) {
                        that.finished = true
                        return
                    }
                } else {
                    toErrorPage(this,'',ret.info,null)
                    // Toast(ret.info)
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.span_class{
    display:block;
    width: 150%;
}
</style>